// client/src/pages/Admin/ResourceManager/constants/resource.constants.ts
import {
    Clock,
    Calendar as CalendarIcon,
    ArrowUpDown,
    RefreshCw,
    Download,
    Eye,
    Star
} from 'lucide-react';
import type { FilterState, SortOption } from '../types/resource.types';

export const RESOURCE_FUNCTIONS = {
    list: '/.netlify/functions/admin-resources',
    get: '/.netlify/functions/admin-resource',
    create: '/.netlify/functions/admin-resource-create',
    update: '/.netlify/functions/admin-resource-update',
    delete: '/.netlify/functions/admin-resource-delete'
} as const;

export const SORT_OPTIONS: SortOption[] = [
    { value: 'newest', label: 'Newest First', icon: Clock, defaultDirection: 'desc' },
    { value: 'oldest', label: 'Oldest First', icon: CalendarIcon, defaultDirection: 'asc' },
    { value: 'alphabetical', label: 'Alphabetical A-Z', icon: ArrowUpDown, defaultDirection: 'asc' },
    { value: 'alphabetical-desc', label: 'Alphabetical Z-A', icon: ArrowUpDown, defaultDirection: 'desc' },
    { value: 'recently-updated', label: 'Recently Updated', icon: RefreshCw, defaultDirection: 'desc' },
    { value: 'downloads', label: 'Most Downloads', icon: Download, defaultDirection: 'desc' },
    { value: 'views', label: 'Most Views', icon: Eye, defaultDirection: 'desc' },
    { value: 'featured', label: 'Featured First', icon: Star, defaultDirection: 'desc' }
];

export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [25, 50, 100];
export const DEBOUNCE_DELAY = 300;
export const MAX_SUGGESTIONS = 8;
export const MAX_VISIBLE_PAGES = 7;
export const TOAST_DURATION = 5000;

export const DEFAULT_FILTERS = {
    status: 'all',
    parentCategory: 'all',
    category: 'all',
    featured: 'all',
    author: 'all',
    year: 'all'
} satisfies FilterState;

export const STAT_CARD_COLORS = {
    total: { color: '#3B82F6', bgColor: '#EFF6FF' },
    published: { color: '#10B981', bgColor: '#ECFDF5' },
    views: { color: '#8B5CF6', bgColor: '#F5F3FF' },
    downloads: { color: '#F59E0B', bgColor: '#FFFBEB' }
};